import React, { useState } from 'react';
import {
  IconButton, ListItemIcon, ListItemText, ListItem, Divider, List, Drawer,
} from '@mui/material';
import Icon from 'screens/shared/icon';
import { _t } from 'utils';
import { useSelector } from 'react-redux';
import { MEDIA_SCREENS_BREAKOUT, ROUTE } from 'constant';
import { service } from 'services';
import Loader from 'screens/shared/loader';
import { getConfig } from 'utils/config';
import { getAssets } from 'themes/assets';
import { featuresToggle } from 'utils/features-toggle';
import { userHasPrivilege, userIsAdmin, userIsContractOwner } from 'utils/privilege';

export default ({ history, show, onClose }) => {
  const [s3Loader, setS3Loader] = useState(false);

  const { layout = {}, screen = {} } = useSelector((e) => e);
  const { menu: selectedMenu = '' } = layout;
  const { width } = screen;

  const { settings = {}, theme = '', features = {} } = getConfig() || {};
  const assets = getAssets();

  const isAdmin = userIsAdmin();
  const isContractOwner = userIsContractOwner();

  const menus = [
    {
      id: ROUTE.DASHBOARD.DATA_CENTERS.key,
      title: _t('Data Centers'),
      icon: { name: 'boxes', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.DATA_CENTERS.path);
      },
    },
    {
      id: ROUTE.DASHBOARD.USER_MANAGEMENT.key,
      title: _t('User Management'),
      icon: { name: 'users', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.USER_MANAGEMENT.path);
      },
    },
    {
      id: ROUTE.DASHBOARD.IMAGES.key,
      title: _t('Images'),
      icon: { name: 'compact-disc', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.IMAGES.path);
      },
    },
    {
      id: ROUTE.DASHBOARD.IPS.key,
      title: _t('IPs'),
      icon: { name: 'network-wired', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.IPS.path);
      },
    },
    {
      id: ROUTE.DASHBOARD.KUBERNETES.key,
      title: _t('Kubernetes'),
      icon: { name: 'asterisk', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.KUBERNETES.path);
      },
    },
    {
      id: 'storage-object',
      title: (
        <span style={{ display: 'flex' }}>
          {_t('Object Storage')}
          {' '}
          <span style={{
            position: 'relative',
            top: -1,
            left: 10,
          }}
          >
            {s3Loader ? (
              <Loader isInline size={12} show />
            ) : <Icon name="external-link-alt" style={{ fontSize: 10, marginLeft: -5 }} /> }
          </span>
        </span>
      ),
      icon: { name: 'cube', style: { fontSize: 20 } },
      handler: () => {
        if (!s3Loader) {
          setS3Loader(true);
          service.s3.getSsoUrl({ }).then(({ ssoUrl }) => {
            let url = ssoUrl;

            if (theme === 'sds') {
              url = url.replace(/(^.+\?)?/, `${settings.s3Endpoint}?`);
            }

            window.open(url, 's3client', 'location=0,width=1180,height=700');
            setS3Loader(false);
            onClose();
          });
        }
      },
    },
    {
      id: ROUTE.DASHBOARD.BACKUP_UNIT.key,
      title: _t('Backup Units'),
      icon: { name: 'layer-group', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.BACKUP_UNIT.path);
      },
    },
    {
      id: ROUTE.DASHBOARD.INVOICES.key,
      title: _t('Invoices'),
      icon: { name: 'money-check-alt', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.INVOICES.path);
      },
      hidden: !features.isInvoicesScreen,
    },
    {
      id: ROUTE.DASHBOARD.MONITORING.key,
      title: 'Monitoring',
      icon: { name: 'chart-line', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.MONITORING.path);
      },
      hidden: !featuresToggle.isMonitoring(),
    },
    {
      id: ROUTE.DASHBOARD.AUTO_SCALING.key,
      title: 'Auto Scaling',
      icon: { name: 'expand-arrows-alt', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.AUTO_SCALING.path);
      },
      hidden: !featuresToggle.isAutoScaling(true),
    },
    {
      id: ROUTE.DASHBOARD.CERTIFICATE_MANAGER.key,
      title: ROUTE.DASHBOARD.CERTIFICATE_MANAGER.title,
      icon: { name: ROUTE.DASHBOARD.CERTIFICATE_MANAGER.icon, style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.CERTIFICATE_MANAGER.path);
      },
      hidden: !featuresToggle.isALB(),
    },
    {
      id: ROUTE.DASHBOARD.TARGET_GROUPS.key,
      title: 'Target Groups',
      icon: { name: 'crosshairs', style: { fontSize: 20 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.TARGET_GROUPS.path);
      },
      hidden: !featuresToggle.isALB(),
    },
    {
      id: ROUTE.DASHBOARD.DATABASES.key,
      title: _t('DATABASES.Databases'),
      icon: { name: 'database', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.DATABASES.path);
      },
      hidden: !featuresToggle.isDatabases() || (!isAdmin && !isContractOwner && !userHasPrivilege('manageDBaaS')),
    },
    {
      id: ROUTE.DASHBOARD.CONTAINER_REGISTRY_LIST.key,
      title: _t('CONTAINER_REGISTRY.CONTAINER_REGISTRY'),
      icon: { name: 'building', style: { fontSize: 18 } },
      handler: () => {
        onClose();
        history.push(ROUTE.DASHBOARD.CONTAINER_REGISTRY_LIST.path);
      },
      hidden: !featuresToggle.isContainerRegistry(),
    },
    // {
    //   id: '',
    //   title: _t('SSH Keys'),
    //   icon: { name: 'key', style: { fontSize: 20 } },
    //   handler: () => {
    //     onClose();
    //     history.push('/ssh-keys');
    //   },
    //   hidden: true,
    // },
  ];

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={show}
      className="drawer"
    >
      <div className="drawer-top">
        <img src={assets.LOGO} alt="Logo" className="drawer-logo" />

        {width < MEDIA_SCREENS_BREAKOUT.TABLET.MIN && (
          <IconButton onClick={onClose} size="large">
            <Icon name="chevron_left" type="material" style={{ color: 'white' }} />
          </IconButton>
        )}
      </div>
      <span className="beta-icon-menu">BETA</span>
      <Divider />
      <List>
        {menus.filter(({ hidden = false }) => !hidden).map(({
          id, title, icon, handler,
        }) => (
          <ListItem
            button
            onClick={handler}
            key={id}
            className={id === selectedMenu ? 'menu-selected' : ''}
          >
            <ListItemIcon><Icon {...icon} /></ListItemIcon>
            <ListItemText primary={title} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};
